import { ReactNode } from 'react'
import { ArrowLink } from './ArrowLink'

type PageHeroProps = {
  title: ReactNode
  body: string
  primary?: { href: string; label: string }
  secondary?: { href: string; label: string }
  visual?: ReactNode
  className?: string
}

export function PageHero({
  title,
  body,
  primary,
  secondary,
  visual,
  className = '',
}: PageHeroProps) {
  return (
    <section className={`page-hero section-dark ${className}`.trim()}>
      <div className="page-hero__copy" data-reveal>
        <h1>{title}</h1>
        <p>{body}</p>
        {(primary || secondary) && (
          <div className="page-hero__actions">
            {primary && (
              <ArrowLink href={primary.href} variant="button">
                {primary.label}
              </ArrowLink>
            )}
            {secondary && <ArrowLink href={secondary.href}>{secondary.label}</ArrowLink>}
          </div>
        )}
      </div>
      {visual && (
        <div className="page-hero__visual" data-reveal>
          {visual}
        </div>
      )}
      <div className="page-hero__signature" aria-label="Informat tagline">
        <span>Technology, quietly mastered.</span>
        <i aria-hidden="true" />
      </div>
    </section>
  )
}
